import { ReactComponent as ReloadIcon } from 'assett/icons/reload.svg';
import { ReactComponent as SearchHideIcon } from 'assett/icons/search_hide_icon.svg';
import { ReactComponent as SearchIcon } from 'assett/icons/search_icon.svg';
import SelectGeneric from 'components/commons/form/SelectGeneric';
import HeaderCellWithSorting from 'components/commons/list/HeaderCellWithSorting';
import {
	handleChange,
	resetInputFilters,
	setSearch,
} from 'feature/form/formSlice';
import { setDownloadAll } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import {
	Box,
	Checkbox,
	DatePicker,
	TableCell,
	TableHead,
	TableRow,
} from 'styles';
import IconButton from 'styles/button/IconButton';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ComplaintTrackingHeader = () => {
	const { downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});

	const dispatch = useDispatch<AppDispatch>();
	const {
		search,
		inputComplaintNotificationDate,
		complaintStatuses,
		inputComplaintStatus,
		complaintSources,
		inputComplaintSource,
		complaintTypes,
		inputComplaintType,
	} = useSelector((store: RootState) => store.form);

	return (
		<TableHead>
			<TableRow>
				<TableCell sx={{ width: 44 }}>
					<Checkbox
						label=""
						onClick={() => {
							dispatch(setDownloadAll(!downloadAll));
						}}
						checked={downloadAll}
						sx={{ p: 0 }}
					/>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="complaintId"
						widthBox={235}
						widthInput={235}
					/>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="externalClaimId"
						widthBox={235}
						widthInput={235}
					/>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="complaintSource"
						widthBox={235}
						widthInput={235}
					>
						<SelectGeneric
							action={status =>
								dispatch(
									handleChange({
										name: 'inputComplaintSource',
										value: status === 'All' ? '' : status,
									}),
								)
							}
							items={[
								{ value: 'All', text: tClientLabels('forms.status.All') },
								...complaintSources.map(el => ({
									value: el.code,
									text: tDbLabels(el.label),
								})),
							]}
							name={'complaintSource'}
							initialValue={inputComplaintSource || 'All'}
							sxForm={{ flex: 1, width: '100%' }}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="complaintType"
						widthBox={235}
						widthInput={235}
					>
						<SelectGeneric
							action={type =>
								dispatch(
									handleChange({
										name: 'inputComplaintType',
										value: type === 'All' ? '' : type,
									}),
								)
							}
							items={[
								{ value: 'All', text: tClientLabels('forms.status.All') },
								...complaintTypes.map(el => ({
									value: el.code,
									text: tDbLabels(el.label),
								})),
							]}
							name={'complaintType'}
							initialValue={inputComplaintType || 'All'}
							sxForm={{ flex: 1, width: '100%' }}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="complaintNotificationDate"
						widthBox={235}
						widthInput={235}
					>
						{search && (
							<Box sx={{ width: 235 }}>
								<DatePicker
									variant="field"
									label={tClientLabels('forms.header.complaintNotificationDate')}
									value={inputComplaintNotificationDate}
									onChange={value =>
										dispatch(
											handleChange({ name: 'inputComplaintNotificationDate', value }),
										)
									}
								/>
							</Box>
						)}
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="complaintStatus"
						widthBox={235}
						widthInput={235}
					>
						<SelectGeneric
							action={status =>
								dispatch(
									handleChange({
										name: 'inputComplaintStatus',
										value: status === 'All' ? '' : status,
									}),
								)
							}
							items={[
								{ value: 'All', text: tClientLabels('forms.status.All') },
								...complaintStatuses.map(el => ({
									value: el.code,
									text: tDbLabels(el.label),
								})),
							]}
							name={'complaintStatus'}
							initialValue={inputComplaintStatus || 'All'}
							sxForm={{ flex: 1, width: '100%' }}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				{
					//this is to fill the void and make the arrow sticky at the end
				}
				<TableCell sx={{ minWidth: 10 }} />
				{
					//this is for the reload button column
				}
				<TableCell sx={{ minWidth: '56px', textAlign: 'center' }}>
					{search && (
						<IconButton onClick={() => dispatch(resetInputFilters())}>
							<ReloadIcon />
						</IconButton>
					)}
				</TableCell>
				<TableCell>
					<IconButton onClick={() => dispatch(setSearch(!search))}>
						{search ? <SearchHideIcon /> : <SearchIcon />}
					</IconButton>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default ComplaintTrackingHeader;
